import * as React from 'react';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Copyright from './internals/components/Copyright';
import ChartUserByCountry from './ChartUserByCountry';
import ChartUserByTemplate from './ChartUserByTemplate';
import CustomizedTreeView from './CustomizedTreeView';
import CustomizedDataGrid from './CustomizedDataGrid';
import HighlightedCard from './HighlightedCard';
import PageViewsBarChart from './PageViewsBarChart';
import SessionsChart from './SessionsChart';
import StatCard from './StatCard';
import Breadcrumbs, { breadcrumbsClasses } from '@mui/material/Breadcrumbs';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';

const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
  margin: theme.spacing(1, 0),
  [`& .${breadcrumbsClasses.separator}`]: {
    color: theme.palette.action.disabled,
    margin: 1,
  },
  [`& .${breadcrumbsClasses.ol}`]: {
    alignItems: 'center',
  },
}));

export default function Dashboard(props) {
  const [selectedRow, setSelectedRow] = React.useState(null);
  const { masivos } = props;

  const [estadisticas, setEstadisticas] = React.useState([]);

  React.useEffect(() => {
    if (masivos.estadisticas?.length > 0) {
      setEstadisticas(masivos?.estadisticas);
    }
  }, [masivos]);

  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1800px' } }}>
      {/* cards */}
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Estadísticas generales
      </Typography>
      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: theme => theme.spacing(2) }}>
        {estadisticas.map((card, index) => (
          <Grid key={index} size={{ xs: 12, sm: 6, lg: 3 }}>
            <StatCard {...card} />
          </Grid>
        ))}
        {/*
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <HighlightedCard />
        </Grid>
        
        <Grid size={{ sm: 12, md: 6 }}>
          <SessionsChart />
        </Grid>
        <Grid size={{ sm: 12, md: 6 }}>
          <PageViewsBarChart />
        </Grid>
        */}
      </Grid>
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        <StyledBreadcrumbs
          aria-label="breadcrumb"
          separator={<NavigateNextRoundedIcon fontSize="small" />}>
          <Typography
            variant="body1"
            sx={{
              cursor: selectedRow?.nombre ? 'pointer' : 'default',
              userSelect: 'none',
              color: 'text.primary',
              fontWeight: selectedRow?.nombre ? 'normal' : 600,
            }}
            onClick={() => setSelectedRow(null)}>
            Campañas enviadas
          </Typography>
          {selectedRow?.nombre && (
            <Typography
              variant="body1"
              sx={{ color: 'text.primary', fontWeight: 600 }}>
              {selectedRow?.nombre}
            </Typography>
          )}
        </StyledBreadcrumbs>
      </Typography>
      <Grid container spacing={2} columns={12}>
        <Grid size={{ md: 12, lg: 12 }}>
          <CustomizedDataGrid
            data={props.masivos?.data}
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
          />
        </Grid>
        {/*<Grid size={{ xs: 12, lg: 3 }}>
          <Stack gap={2} direction={{ xs: 'column', sm: 'row', lg: 'column' }}>
            <ChartUserByTemplate />
            <ChartUserByCountry />
          </Stack>
        </Grid>
        */}
      </Grid>
    </Box>
  );
}
